const successColors = {
  SUCCESS_50: '#E8F5E9',
  SUCCESS_100: '#C8E6C9',
  SUCCESS_200: '#A5D6A7',
  SUCCESS_300: '#81C784',
  SUCCESS_400: '#66BB6A',
  SUCCESS_500: '#4CAF50',
  SUCCESS_600: '#43A047',
  SUCCESS_700: '#388E3C',
  SUCCESS_800: '#2E7D32',
  SUCCESS_900: '#1B5E20',
}

export default successColors
